<template>
  <div class="grid grid-cols-1 gap-y-2">
    <div>
      <SelectLanguages
        v-model="localPrintSettings.language"
        :label="$t('attributes.language')"
        edition-mode
        customer-language-only
        required
      />
    </div>

    <div class="grid grid-cols-2 gap-y-2">
      <div class="flex flex-col">
        <div>
          <WalkmanButton
            v-model="localPrintSettings.recto_verso"
            :label="$t('attributes.recto_verso')"
            :options="[
              { value: true, label: $t('enums.yesNo.1') },
              { value: false, label: $t('enums.yesNo.0') }
            ]"
            :edition-mode="!localPrintSettings.electronic_signature"
            size="small"
          />
        </div>
        <small
          v-if="localPrintSettings.electronic_signature"
          class="capitalize-first mt-0.5 text-xs text-gray-500"
        >
          {{ $t('hint.recto_verso_disabled_by_electronic_signature', "Désactivé lors d'une signature électronique") }}
        </small>
      </div>

      <div class="flex flex-col">
        <div>
          <WalkmanButton
            v-model="localPrintSettings.page_numbering"
            :label="$t('attributes.page_numbering')"
            :options="[
              { value: true, label: $t('enums.yesNo.1') },
              { value: false, label: $t('enums.yesNo.0') }
            ]"
            size="small"
          />
        </div>
      </div>

      <div class="flex flex-col">
        <div>
          <WalkmanButton
            v-model="localPrintSettings.general_conditions"
            :label="$t('attributes.general_conditions')"
            :options="[
              { value: true, label: $t('enums.yesNo.1') },
              { value: false, label: $t('enums.yesNo.0') }
            ]"
            size="small"
          />
        </div>
      </div>

      <div class="flex flex-col">
        <div>
          <WalkmanButton
            v-model="localPrintSettings.payment_historic"
            :label="$t('attributes.payments')"
            :options="[
              { value: true, label: $t('enums.yesNo.1') },
              { value: false, label: $t('enums.yesNo.0') }
            ]"
            size="small"
          />
        </div>
      </div>

      <div class="flex flex-col">
        <div>
          <WalkmanButton
            v-model="localPrintSettings.qrcode_tracking"
            label="QRcode tracking"
            :options="[
              { value: true, label: $t('enums.yesNo.1') },
              { value: false, label: $t('enums.yesNo.0') }
            ]"
            size="small"
          />
        </div>
      </div>
      <div
        v-if="invoice.dossier_id &&
        invoice?.invoiceable?.country === Country.FRANCE"
        class="flex flex-col"
      >
        <div>
          <WalkmanButton
            v-model="localPrintSettings.hide_deceased_summary"
            label="Masquer le résumé défunt"
            name="hide_deceased_summary"
            :options="[
              { value: true, label: $t('enums.yesNo.1') },
              { value: false, label: $t('enums.yesNo.0') }
            ]"
            size="small"
          />
        </div>
      </div>
      <div class="mt-4 flex flex-col col-start-1">
        <div>
          <WalkmanButton
            v-model="localPrintSettings.display_ref"
            :label="$t('global.display_ref')"
            :options="[
              { value: true, label: $t('enums.yesNo.1') },
              { value: false, label: $t('enums.yesNo.0') }
            ]"
            size="small"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import WalkmanButton from '@c/WalkmanButton'
import SelectLanguages from '@c/InitialStateFormComponent/Enums/SelectLanguages.vue'
import { Country } from '@/assets/enums'

export default {
  name: 'TheInvoicingPrintOptionsForm',
  components: {
    SelectLanguages,
    WalkmanButton
  },
  props: {
    printSettings: {
      type: Object,
      required: true
    }
  },
  emits: ['update:printSettings'],
  computed: {
    ...mapGetters({
      errors: 'auth/getErrors',
      initialMetadata: 'metadata/getInitialMetadata',
      invoice: 'invoicing/getInvoice',
      auth: 'auth/getAuth'
    }),
    Country() {
      return Country
    },
    localPrintSettings: {
      get() {
        return this.printSettings
      },
      set(value) {
        this.$emit('update:printSettings', value)
      }
    }
  }
}
</script>
